import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type * as v from 'valibot';
import { COLORS_MAP } from '../../constants';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { BORDER_RADIUS_MAP } from './constants';
import type { columnSCSchema } from './schema';
export type ColumnProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof columnSCSchema> & {
  collapse?: boolean;
}>;
export const CSS_VARIABLES = {
  gridColumnEnd: '--nw-sc-Column-gridColumnEnd'
};
export const Column = t0 => {
  const $ = _c(34);
  const {
    props
  } = t0;
  const {
    backgroundColor,
    borderRadius,
    children,
    collapse: t1,
    columnStart,
    equalHeight,
    order,
    padding,
    width
  } = props;
  const collapse = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== width) {
    t2 = device => {
      if (typeof width === "object") {
        return width[device];
      }
      return width;
    };
    $[0] = width;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getWidth = t2;
  let t3;
  if ($[2] !== order) {
    t3 = device_0 => {
      if (typeof order === "object") {
        return order[device_0];
      }
      return order;
    };
    $[2] = order;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getOrder = t3;
  const t4 = padding || 0;
  const t5 = equalHeight ? "100%" : undefined;
  const t6 = COLORS_MAP[backgroundColor || "transparent"];
  const t7 = BORDER_RADIUS_MAP[borderRadius || 0];
  const t8 = columnStart ?? undefined;
  let t9;
  if ($[4] !== getOrder || $[5] !== order) {
    t9 = order ? getOrder("mobile") : undefined;
    $[4] = getOrder;
    $[5] = order;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== getOrder || $[8] !== order) {
    t10 = order ? getOrder("desktop") : undefined;
    $[7] = getOrder;
    $[8] = order;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = {
      xs: t9,
      sm: t10
    };
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== collapse || $[14] !== getWidth) {
    t12 = collapse ? undefined : `span var(${CSS_VARIABLES.gridColumnEnd}, ${Number(getWidth("mobile"))})`;
    $[13] = collapse;
    $[14] = getWidth;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== getWidth) {
    t13 = getWidth("desktop");
    $[16] = getWidth;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = `span var(${CSS_VARIABLES.gridColumnEnd}, ${Number(t13)})`;
  let t15;
  if ($[18] !== t12 || $[19] !== t14) {
    t15 = {
      xs: t12,
      sm: t14
    };
    $[18] = t12;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t11 || $[22] !== t15 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t16 = {
      padding: t4,
      height: t5,
      bgcolor: t6,
      borderRadius: t7,
      gridColumnStart: t8,
      order: t11,
      gridColumnEnd: t15
    };
    $[21] = t11;
    $[22] = t15;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== children) {
    t17 = renderStructuredContent(children);
    $[29] = children;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t16 || $[32] !== t17) {
    t18 = <Box sx={t16}>{t17}</Box>;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
};